module.exports = __webpack_public_path__ + "static/media/Sage_(Full).6dded2c1.png";